import { LoaderComponent } from './interceptor/loader/loader.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterService } from './servizi/router.service';
import { LoaderInterceptor } from './interceptor/loading.interceptor.service';
import { LoaderService } from './interceptor/loader.service';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MapModule } from './library/ebw-map-angular/map.module';
import { EbwModalModule } from './library/ebw-modals-angular/ebw-modal.module';
import { EbwToastModule } from './library/ebw-toast-angular/ebw-toast.module';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { MenuComponent } from './home/menu/menu.component';
import { HeaderComponent } from './home/header/header.component';
import { LoginComponent } from './login/login.component';
import { SimulazioneUtenteComponent } from './login/simulazione-utente/simulazione-utente.component';
import { MappaComponent } from './mappa/mappa.component';
import { HttpClient } from '@angular/common/http';
import { RenderEngineService } from 'src/app/servizi/render-engine.service';
import { ConfigService } from 'src/app/servizi/config/config.service';
import { GestioneLoginService } from './servizi/login/gestione-login.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MappaService } from './servizi/mappa/mappa.service';
import { NotificheComponent } from './home/header/notifiche/notifiche.component';
import { ControllerMessaggiService } from './servizi/controller-messaggi.service';
import { UtilsService } from './servizi/utils.service';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { CommonModule } from '@angular/common';
import { FilterActivePipe } from './servizi/pipes/filter-active.pipe';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AnalisysManagementComponent } from './analisys-management/analisys-management.component';
import { UserProfileComponent } from './home/header/user-profile/user-profile.component';
import { ReportOmiComponent } from './modali/report-omi/report-omi.component';
import { ReportBtsComponent } from './modali/report-bts/report-bts.component';
// import { RecuperoPasswordComponent } from './login/recupero-password/recupero-password.component';
import { SolrAutocompleteComponent } from './condivisa/solr-autocomplete/solr-autocomplete.component';
import { ObjectDetailsComponent } from './home/object-info/object-details/object-details.component';
import { ObjectInfoComponent } from './home/object-info/object-info.component';
import { RelatedItemsComponent } from './home/object-info/related-items/related-items.component';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from './home/object-info/pagination/pagination.component';
import { RelatedItemComponent } from './home/object-info/related-items/related-item/related-item.component';
import { NamService } from './servizi/nam/nam.service';
import { NamSelectedObjectService } from './servizi/nam/nam-object-selected.service';
import { BreadcrumbComponent } from './home/object-info/breadcrumb/breadcrumb.component';
import { RelatedItemsHistoryComponent } from './home/object-info/related-items-history/related-items-history.component';
import { TemplatesContainerComponent } from './home/object-info/modal/templates-container/templates-container.component';
import { ObjectTemplateComponent } from './home/object-info/modal/templates-container/object-template/object-template.component';
import { SelectPopupComponent } from './home/object-info/select-popup/select-popup.component';
import { TemplateDetailsComponent } from './home/object-info/object-details/template-details/template-details.component';
// import { WebsocketService } from './servizi/websocket.service';
import { ListComponent } from './library/list/list.component';
import { RicercaAnalisiComponent } from './ricerca-analisi/ricerca-analisi.component';
import { ListModule } from './library/ebw-list-angular/list.module';
import { AnalysisPropertyModalComponent } from './analysis/analysis-property-modal/analysis-property-modal.component';
import { GestioneAnalisiMassivaComponent } from './gestione-analisi-massiva/gestione-analisi-massiva.component';
import { AnalysisModalEditComponent } from './gestione-analisi-massiva/analysis-modal-edit/analysis-modal-edit.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { AnalysisModalAssociaComponent } from './gestione-analisi-massiva/analysis-modal-associa/analysis-modal-associa.component';
import { RefreshTokenInterceptor } from './interceptor/refresh-token.interceptor.service';

/** NgModule */
@NgModule({
   declarations: [
      AppComponent,
      HomeComponent,
      SimulazioneUtenteComponent,
      SolrAutocompleteComponent,
      MappaComponent,
      LoginComponent,
      MenuComponent,
      // RecuperoPasswordComponent,
      HeaderComponent,
      NotificheComponent,
      FilterActivePipe,
      LoaderComponent,
      AnalisysManagementComponent,
      UserProfileComponent,
      ReportOmiComponent,
      ReportBtsComponent,
      ListComponent, // app-list
      ObjectInfoComponent,
      ObjectDetailsComponent,
      RelatedItemsComponent,
      PaginationComponent,
      RelatedItemComponent,
      BreadcrumbComponent,
      RelatedItemsHistoryComponent,
      TemplatesContainerComponent,
      ObjectTemplateComponent,
      SelectPopupComponent,
      TemplateDetailsComponent,
      RicercaAnalisiComponent,
      AnalysisPropertyModalComponent,
      GestioneAnalisiMassivaComponent,
      AnalysisModalAssociaComponent,
      AnalysisModalEditComponent,
   ],
   imports: [
      NgbModule,
      BrowserModule,
      AppRoutingModule,
      FormsModule,
      HttpClientModule,
      ReactiveFormsModule,
      FontAwesomeModule,
      BrowserAnimationsModule,
      EbwModalModule,
      EbwToastModule,
      CommonModule,
      MapModule.forRoot({ apiKey: 'AIzaSyDjcv-cWws-By2x0LH9Piun5IUc9FFTqWQ', libraries: ['places'] }),
      LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG, enableSourceMaps: true, serverLogLevel: NgxLoggerLevel.OFF, disableConsoleLogging: false }),
      NgxSpinnerModule,
      NgbPaginationModule,
      ListModule,// ebw-list,
      ColorPickerModule
   ],
   providers: [
      HttpClient,
      GestioneLoginService,
      RenderEngineService,
      ConfigService,
      MappaService,
      ControllerMessaggiService,
      UtilsService,
      NgbActiveModal,
      DatePipe,
      LoaderService,
      RouterService,
      NamService,
      NamSelectedObjectService,
      // WebsocketService,
      { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true }
   ],
   entryComponents: [],
   bootstrap: [AppComponent],
   schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }